<template>
  <dashboards-filters :filters="dashboardFilters" use-action-users>
    <template #prepend>
      <select-filter v-model="actionsOptions.groupBy"
                     :items="groupByOptions"
                     :label="$t('MONITORING_ACTIONS.FILTERS.GROUP_BY')" :menu-props="{ location: 'bottom' }" style="flex: 1 0 120px">
      </select-filter>
      <div class="mx-4 my-n4">
        <v-switch v-model="actionsOptions.displayCompleted" density="compact" class="my-n4">
          <template #label>
            <small>{{ $t('MONITORING_ACTIONS.FILTERS.DISPLAY_COMPLETED_ACTIONS') }}</small>
          </template>
        </v-switch>
        <v-switch v-model="actionsOptions.withWorkloadOnly" density="compact" class="my-n4">
          <template #label>
            <small>{{ $t('MONITORING_ACTIONS.FILTERS.WITH_WORKLOAD_ONLY') }}</small>
          </template>
        </v-switch>
      </div>
      <v-menu v-model="dropdownIsOpen" :close-on-content-click="false" location="bottom end">
        <template #activator="{ props }">
          <v-btn icon color="secondary" size="small" v-bind="props">
            <v-badge :model-value="!! actionsOptions.title" color="successgreen" floating dot>
              <v-icon>far fa-search</v-icon>
            </v-badge>
            <v-tooltip :disabled="dropdownIsOpen" location="bottom" activator="parent">{{ $t('GLOBAL.SEARCH') }}</v-tooltip>
          </v-btn>
        </template>
        <v-list class="pt-4 pb-8">
          <v-list-item class="d-block">
            <text-filter :model-value="actionsOptions.title" :label="$t('MONITORING_ACTIONS.FILTERS.FILTER_ACTIONS')" :placeholder="$t('MONITORING_ACTIONS.FILTERS.SEARCH_TITLE')"
                         id="actions-dashboard-search-input" clearable style="min-width: 190px"
                         @change="actionsOptions.title = $event.target.value" @keydown.enter="actionsOptions.title = $event.target.value" @click:clear="actionsOptions.title = ''">
            </text-filter>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="dashboard-filters-spacer"></div>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </dashboards-filters>
</template>

<script>
  import { mapState } from 'pinia';
  import DashboardsFilters from '../DashboardsFilters/DashboardsFilters.vue';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import useMultiprojectsStore from '@/stores/multiprojects/multiprojects';

  export default {
    components: {
      DashboardsFilters,
    },
    data() {
      return {
        dropdownIsOpen: null,
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      dashboardFilters() {
        return ['Projects', this.actionsOptions.groupBy == 'group' ? 'GroupUsers' : 'Users', 'Dates'];
      },
      groupByOptions() {
        const options = [{ value: 'user', title: this.$t('MULTIPROJECTS.USERS') }, { value: 'planning', title: this.$t('MULTIPROJECTS.PROJECTS') }];
        if (this.isBusiness) options.push({ value: 'group', title: this.$t('GLOBAL.GROUPS') });
        return options;
      },
      isBusiness() { return this.usersAccessRightStore.isBusiness; },
      ...mapState(useMultiprojectsStore, ['actionsOptions']),
    },
    watch: {
      'actionsOptions.title': function () {
        this.dropdownIsOpen = false;
      },
      dropdownIsOpen(newVal) {
        if (newVal) {
          setTimeout(() => document.getElementById('actions-dashboard-search-input')?.focus(), 100);
        }
      },
    },
  };
</script>
